import { action } from 'easy-peasy';

const avatarModel = {
  avatars: [],
  selectedAvatarId: null,
  voices: [],
  voiceByScene: {},

  setAvatars: action((state, payload) => {
    state.avatars = payload;
  }),
  setSelectedAvatarId: action((state, payload) => {
    state.selectedAvatarId = payload;
  }),
  setVoices: action((state, payload) => {
    state.voices = payload;
  }),
  setVoiceByScene: action((state, payload) => {
    state.voiceByScene = payload;
  })
};

export default avatarModel;
